(function () {
  function weekKey(week) {
    return 'fi-akla-feedback-submitted:' + week;
  }

  function dismissedKey(week) {
    return 'fi-akla-feedback-dismissed:' + week;
  }

  function safeGet(storage, key) {
    try { return storage.getItem(key); } catch (error) { return null; }
  }

  function safeSet(storage, key, value) {
    try { storage.setItem(key, value); } catch (error) {}
  }

  function initReminder() {
    var reminder = document.querySelector('[data-fi-feedback-reminder]');
    if (!reminder) return;

    var week = reminder.getAttribute('data-feedback-week');
    if (safeGet(window.localStorage, weekKey(week)) || safeGet(window.sessionStorage, dismissedKey(week))) return;

    reminder.hidden = false;

    var dismiss = reminder.querySelector('[data-fi-feedback-dismiss]');
    if (dismiss) {
      dismiss.addEventListener('click', function () {
        safeSet(window.sessionStorage, dismissedKey(week), '1');
        reminder.hidden = true;
      });
    }
  }

  function showFeedbackThanks(page, week) {
    safeSet(window.localStorage, weekKey(week), new Date().toISOString());

    var shell = page.querySelector('.fi-feedback-page__form-shell');
    var thanks = page.querySelector('[data-fi-feedback-thanks]');

    if (shell) {
      shell.hidden = true;
      shell.setAttribute('aria-hidden', 'true');
    }

    if (thanks) {
      thanks.hidden = false;
      thanks.setAttribute('tabindex', '-1');
      thanks.focus({ preventScroll: true });
    }
  }

  function bridgeSimplyFormsSuccess(page, week) {
    var shell = page.querySelector('.fi-feedback-page__form-shell');
    if (!shell) return;

    var submitted = false;
    var observer = null;

    shell.addEventListener('submit', function () {
      submitted = true;

      if (observer) observer.disconnect();
      observer = new MutationObserver(function () {
        if (!submitted) return;

        var submitControl = shell.querySelector('input[type="submit"], button[type="submit"]');
        var visibleMessage = shell.innerText.trim();

        if (!submitControl && visibleMessage) {
          observer.disconnect();
          showFeedbackThanks(page, week);
        }
      });

      observer.observe(shell, { childList: true, subtree: true });
    }, true);
  }

  function initFeedbackPage() {
    var page = document.querySelector('[data-fi-feedback-page]');
    if (!page) return;

    var params = new URLSearchParams(window.location.search);
    var week = params.get('week') || page.getAttribute('data-feedback-week');

    if (params.get('feedback') === 'thanks') {
      showFeedbackThanks(page, week);
      return;
    }

    bridgeSimplyFormsSuccess(page, week);
  }

  function init() {
    initReminder();
    initFeedbackPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();